exports.__esModule = true;
exports.supabase = void 0;
var supabase_js_1 = require("@supabase/supabase-js");
var supabaseUrl = 'https://lsisaddtkebiikxnuhms.supabase.co';
var supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxzaXNhZGR0a2ViaWlreG51aG1zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxODk5NjcsImV4cCI6MjA2Mjc2NTk2N30.SW86xi8dc4TdH94NRVfG3AJOjDFDGvzdalUBXIkeGFk';
exports.supabase = (0, supabase_js_1.createClient)(supabaseUrl, supabaseAnonKey);
